/**
 * Async operations queue
 */
let _cancellationHandlerMap = new Map();

/**
 *
 */
const runAllCancellationHandlers = () => {
  const handlers = Array.from(_cancellationHandlerMap.values());
  for (const cancellationHandler of handlers) {
    cancellationHandler();
  }
  _cancellationHandlerMap.clear();
};

/**
 *
 * @param {*} action
 * @param {*} delay The time, in milliseconds that the timer should wait before the specified action is executed
 * @param {*} args
 */
const delayCall = (action, delay = 0, ...args) => {
  if (action === undefined) {
    throw new Error('Invalid action to call');
  }

  if (delay <= 0) {
    throw new Error('Invalid delay. Value must be numeric and greater than 0');
  }

  const handler = setTimeout(()=>{
    action?.apply(null, [...args]);
    _cancellationHandlerMap.delete(handler);
  }, delay);

  const cancellationHandler = () => { clearTimeout(handler); }
  _cancellationHandlerMap.set(handler, cancellationHandler);

  return cancellationHandler;
}


export { delayCall, runAllCancellationHandlers};